import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UserService, ScrollParams, ScrollService } from '../../api';
import * as _ from 'lodash';
import 'intl';
import 'intl/locale-data/jsonp/en';

@Component({
  selector: 'user-activity',
  templateUrl: './user-activity.component.html',
  styleUrls: ['./user-activity.component.css']
})
export class UserActivityComponent implements OnInit, OnDestroy {
  @Input() index;
  private activities: Array<any> = new Array<any>();
  private loading: boolean = true;
  private scrollParams = new ScrollParams();
  private scrollSubscriber = null;
  enableScrollForActivities = true;
  // to get the user activites only once for now
  callOnce = true;
  private eventText = [{
    WG_EVENT_LIFESTYLE_INFO_DONE: {
      text: 'modified lifestyle information',
      icon: '/assets/icons/menu.svg'
    },
    WG_EVENT_BASIC_PROFILE: {
      text: 'modified basic profile',
      icon: '/assets/icons/menu.svg'
    },
    EVENT_CHANGE_SCREENNAME: {
      text: 'Changed screenname',
      icon: '/assets/icons/menu.svg'
    },
    WG_PLAYLIST_PLAYED: {
      text: 'played the playlist',
      icon: '/assets/icons/menu.svg'
    },
    WG_EVENT_ADDED_TO_PLAYLIST: {
      text: ' added to playlist',
      icon: '/assets/icons/menu.svg'
    },
    WG_SONG_PLAYED: {
      text: 'played the song',
      icon: '/assets/icons/menu.svg'
    },
    WG_EVENT_SONG_LIKE: {
      text: 'liked the song',
      icon: '/assets/icons/menu.svg'
    },
    WG_EVENT_PLAYLIST_LIKE: {
      text: 'liked playlist',
      icon: '/assets/icons/menu.svg'
    },
    WG_EVENT_ARTIST_FOLLOW: {
      text: 'followed artist',
      icon: '/assets/icons/menu.svg'
    },
    WG_ARTIST_PLAYED: {
      text: 'played the artist',
      icon: '/assets/icons/menu.svg'
    },
    WG_EVENT_USER_FOLLOW: {
      text: 'followed user',
      icon: '/assets/icons/menu.svg'
    },
    WG_EVENT_ALBUM_LIKE: {
      text: 'liked album',
      icon: '/assets/icons/menu.svg'
    },
    WG_EVENT_ADDED_TO_DISCOVERED: {
      text: 'added to discoveries',
      icon: '/assets/icons/menu.svg'
    },
    WG_SONG_PLAYED_FROM_RADIO: {
      text: 'radio Played',
      icon: '/assets/icons/menu.svg'
    }
  }];
  public onlineOffline: boolean = navigator.onLine;

  constructor(private userService: UserService, private scrollService: ScrollService) {
    window.addEventListener('online', () => {this.onlineOffline = true;});
    window.addEventListener('offline', () => {this.onlineOffline = false;});
  }

  ngOnInit() {
    this.getActivityData();
    this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getActivityData());
  }

  getActivityData() {
    if (this.scrollParams.recordsFinished) {
      return;
    }
    this.loading = true;
    if(this.onlineOffline && this.index == 0 && this.enableScrollForActivities && this.callOnce == true) {
      this.enableScrollForActivities = false;
      this.callOnce = false;
      this.userService.loadDashboardActivities(this.scrollParams).subscribe((res) => {
        if (res.length > 0) {
          res.forEach((arrayItem) => {
            this.activities.push(arrayItem);
          });
          this.scrollParams.page++;
          this.enableScrollForActivities = true;
        } else {
          this.enableScrollForActivities = false;
          this.scrollParams.recordsFinished = false;
        }
        if(res.length == 0 || res.length < 20) {
          this.enableScrollForActivities = false;
        }
        this.activities = _.uniqBy(this.activities, 'id');
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }

  ngOnDestroy() {
    if (this.scrollSubscriber != null) {
      this.scrollSubscriber.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/user-activity/user-activity.component.ts